import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useSelector } from "react-redux";
import Validator from "../../../utils/formValidator";
import axios from "axios";
import { api_config } from "../../../constants/api";
import { useTranslation } from "react-i18next";
import { ReactComponent as PasswordShow } from "../../../assets/icons/showPassword.svg";
import { ReactComponent as PasswordHide } from "../../../assets/icons/hidePassword.svg";
import { ReactComponent as Comeback } from '../../../assets/icons/comback.svg'
export default function ResetPassword(props) {
  const [loading, setLoading] = useState(false);
  const reducerData = useSelector((state) => state.userinfo);
  const { t } = useTranslation(["userLoginTips"]);
  const [form] = Form.useForm();
  const passWordIconRender = (visible) => {
    return visible ? <PasswordShow /> : <PasswordHide />;
  };

  const comeback = () => {
    props.changeStep(4)
  }
  const onSubmit = (value) => {
    setLoading(true);
    console.log("value", value);
    let userEmail =
      reducerData.userEmail.email || localStorage.getItem("userResetEmail");
    let code =
      reducerData.userEmail.verificationCode ||
      localStorage.getItem("verificationCode");
    let token =
      reducerData.emailToken.token || localStorage.getItem("emailToken");
    let formData = new FormData();
    formData.append("email", userEmail);
    formData.append("code", code);
    formData.append("token", token);
    formData.append("new_password", value.password);
    formData.append("new_password_confirmation", value.password);
    axios({
      method: "POST",
      url: api_config.API_V2_URL + "accounts/password-reset",
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          message.success(t("Passwordresetsuccessfully"));
          props.changeStep(2);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        let res = err.response;
        if (res.status === 500) {
          message.error(t("500"));
        } else {
          switch (res.data.code) {
            case 400301:
              message.error(
                t("Invalidverificationcodepleasereenterthecorrectone")
              );
              break;
            case 400204:
              message.error(
                t(
                  "ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword"
                )
              );
              break;
            default:
              message.error(t("500"));
          }
        }
      });
  };

  return (
    <div className="resetPassword">
      <div>
        <Comeback onClick={comeback} className="comeback" />
        <div className="loginTitle"> {t("Resetpassword")}</div>
        <Form
          onFinish={onSubmit}
          layout="vertical"
          name="resetPassword"
          form={form}
        >
          <Form.Item
            initialValue={reducerData.userEmail.email}
            label={
              <div className="emailTitle">
                <div className="circle" />
                {t("Email")}
              </div>
            }
          >
            <Input
              disabled
              defaultValue={reducerData.userEmail.email}
              placeholder={t("Email")}
              className="inputForm"
            />
          </Form.Item>
          <Form.Item
            name="password"
            className="formItem"
            validateTrigger="onBlur"
            rules={[
              {
                validator: Validator.passwordValidator,
              },
            ]}
            getValueFromEvent={(e) => {
              return e.target.value.replace(/\s+/g, "");
            }}
            label={
              <div className="passwordTitle">
                <div className="circle" />
                {t("Password")}
              </div>
            }
          >
            <Input.Password
              iconRender={passWordIconRender}
              className="inputForm"
              placeholder={t("Password")}
            />
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading}
              className="resetBtn"
              type="primary"
              htmlType="submit"
            >
              {t("Confirm")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
